// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"59714a4e","251":"1a1173df","348":"840cc120","364":"baeba280","571":"52fd57f8"}[chunkId] + ".chunk.js";
};